import React from 'react';

interface LocationSelectorProps {
  location: string;
  locationOther: string;
  onLocationChange: (location: string) => void;
  onLocationOtherChange: (locationOther: string) => void;
  required?: boolean;
  disabled?: boolean;
}

export const LOCATION_OPTIONS = [
  { value: 'Cardiff', label: 'Cardiff' },
  { value: 'Dublin', label: 'Dublin' },
  { value: 'Hyderabad', label: 'Hyderabad' },
  { value: 'Other', label: 'Other' }
];

const LocationSelector: React.FC<LocationSelectorProps> = ({
  location,
  locationOther,
  onLocationChange,
  onLocationOtherChange,
  required = false,
  disabled = false
}) => {
  return (
    <div style={{ marginBottom: '20px' }}>
      <label style={{ display: 'block', marginBottom: '5px', fontWeight: 'bold' }}>
        Location {required && <span style={{ color: 'red' }}>*</span>}:
      </label>
      <select
        value={location}
        onChange={(e) => onLocationChange(e.target.value)}
        style={{ 
          width: '100%', 
          padding: '8px', 
          borderRadius: '4px', 
          border: '1px solid #ccc',
          fontSize: '14px',
          marginBottom: location === 'Other' ? '10px' : '0'
        }}
        required={required}
        disabled={disabled}
      >
        <option value="">Select location</option>
        {LOCATION_OPTIONS.map(option => (
          <option key={option.value} value={option.value}>
            {option.label}
          </option>
        ))}
      </select>
      <small style={{ color: '#666', fontSize: '12px', display: 'block', marginTop: '5px' }}>
        Your location helps with merch and catering ordering
      </small>
      
      {location === 'Other' && (
        <div style={{ marginTop: '10px' }}>
          <input
            type="text"
            value={locationOther}
            onChange={(e) => onLocationOtherChange(e.target.value)}
            placeholder="Please specify your location"
            style={{ 
              width: '100%', 
              padding: '8px', 
              borderRadius: '4px', 
              border: '1px solid #ccc',
              fontSize: '14px'
            }}
            required={location === 'Other'}
            disabled={disabled}
          />
          <small style={{ color: '#666', fontSize: '12px' }}>
            Please provide your specific location
          </small>
        </div>
      )}
    </div>
  );
};

export default LocationSelector;
